import React, { useEffect, useState } from 'react'
import { debounce } from '../../../Utils/Functions'
import ChatParticipantsSearchView from '../component/ChatParticipantsSearchView'
import { authorization } from '../../../Module/Auth/Auth'

const ChatParticipantsSearch = props => {
  const [searchString, setSearchString] = useState('')
  const [suggestions, setSuggestions] = useState([])

  const {
    style,
    placeholder,
    showButton,
    selectedParticipants,
    setSelectedParticipants,
    cityIds,
    searchRequestHandler,
    selectedRole,
  } = props
  const areCityIsNotSelected = cityIds.length == 0 || cityIds.includes('All')
  const isCityManager = authorization.isCityManager()
  useEffect(() => {
    if (areCityIsNotSelected && searchString.length < 2 && !isCityManager) {
      setSuggestions([])
    }
  }, [suggestions, searchString])

  const onChange = async (event, { newValue }) => {
    setSuggestions([])
    setSearchString(newValue)
    initSearch(newValue)
  }

  useEffect(() => {
    if (
      (!searchString || searchString == '') &&
      areCityIsNotSelected &&
      !isCityManager
    ) {
      setSuggestions([])
    }
    initSearch(searchString)
  }, [selectedRole, cityIds])

  const initSearch = debounce(async str => {
    const areCityIsNotSelected = cityIds.length == 0 || cityIds.includes('All')
    if (str.length < 2 && areCityIsNotSelected && !isCityManager) return
    const searchRequestResult = await searchRequestHandler({
      searchString: str,
      selectedCities: cityIds,
      selectedRole,
    })
    await setSuggestions(searchRequestResult)
  }, 200)

  const handleSuggestionsFetchRequested = async ({ value }) => {
    //await initSearch()
  }

  const onSuggestionSelected = (event, { suggestion }) => {
    props.onSuggestionSelected(suggestion)
    setSearchString('')
    setSuggestions([])
  }

  const onUserClick = ({ id, name, role, cityId, profilePicture }) => {
    const alreadySelected = selectedParticipants.find(
      ({ id: oldId }) => oldId == id,
    )
    if (alreadySelected) {
      const newParticipants = selectedParticipants.filter(
        ({ id: oldId }) => oldId !== id,
      )
      setSelectedParticipants(newParticipants)
    } else {
      const newParticipants = [
        ...selectedParticipants,
        { id, name, role, cityId, profilePicture },
      ]
      setSelectedParticipants(newParticipants)
    }
  }

  return (
    <ChatParticipantsSearchView
      style={style}
      placeholder={placeholder}
      showButton={showButton}
      onChange={onChange}
      onUserClick={onUserClick}
      selectedParticipants={selectedParticipants}
      inputValue={searchString}
      suggestions={suggestions}
      onSuggestionSelected={onSuggestionSelected}
      handleSuggestionsClearRequested={() => {}}
      handleSuggestionsFetchRequested={handleSuggestionsFetchRequested}
    />
  )
}
export default ChatParticipantsSearch
